import {Component, OnInit} from '@angular/core';
import {RedirectService} from '../../../services/redirect/redirect.service';
import {ActivatedRoute, RouterLink} from '@angular/router';
import {LangTgtService} from '../../../services/lang-tgt/lang-tgt.service';
import {LangSrcService} from '../../../services/lang-src/lang-src.service';
import {EvaluationService} from '../../../services/evaluation/evaluation.service';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {SpinnerComponent} from '../../../components/spinner/spinner.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {PlatformOnboardingModalComponent} from '../../../components/platform-onboarding-modal/platform-onboarding-modal.component';

@Component({
  selector: 'app-evaluation-select-profile',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    TranslateModule,
    SpinnerComponent
  ],
  templateUrl: './evaluation-select-profile.component.html',
  styleUrls: ['./evaluation-select-profile.component.scss']
})
export class EvaluationSelectProfileComponent implements OnInit {

  loading = true;
  history: any[] = [];

  constructor(
    public langSrcSrv: LangSrcService,
    private langTgtSrv: LangTgtService,
    private redirectSrv: RedirectService,
    private evaluationSrv: EvaluationService,
    private route: ActivatedRoute,
    private modal: NgbModal,
  ) {
  }

  trackByIndex(index: number) { return index; }

  async ngOnInit() {
    this.history = (await this.evaluationSrv.history(this.route.snapshot.params.langTgt) as any[]) || [];
    this.loading = false;
  }

  async play() {
    await this.evaluationSrv.skip(this.route.snapshot.params.langTgt);
    const language = this.langTgtSrv.langs.find(x => x.code === this.route.snapshot.params.langTgt);
    await this.redirectSrv.toPlatform(language);
  }

  openPlatformInfo() {
    this.modal.open(PlatformOnboardingModalComponent, {
      centered: true,
      size: 'lg',
    });
  }

}
